import { createFileRoute } from "@tanstack/react-router";

import Setlists from "@/features/gigs/Setlists";
import SideNavLayout from "@/layouts/SideNavLayout";
import { GigsMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/gigs/setlists/")({
  component: () => (
    <SideNavLayout menu={<GigsMenu />}>
      <div className="min-w-0 overflow-x-hidden">
        <Setlists />
      </div>
    </SideNavLayout>
  ),
});
